import z from "zod";

/**
 * CancelarOrdemCompraSchema
 */

export const CancelarOrdemCompraSchema = z.object({
  motivo: z.string().nullable().default(null),
});

/**
 * CancelarOrdemCompraForm
 */

export type CancelarOrdemCompraForm = z.infer<typeof CancelarOrdemCompraSchema>;